<template>
<div id="report_container" >
  <div class="card gl-container-shadow reports-content">
    <ul id="nav_report" class="nav nav-tabs report-tabs" v-if="tabs != null && Object.keys(tabs).length > 0">
      <li class="nav-item" v-for="(tab, index) in tabs" >
        <a class="nav-link active" v-on:click="loadTab(tab.id)" :id="tab.id"  href="#">{{index}}</a>
      </li>
    </ul>
    <iframe  v-if="tabs != null && Object.keys(tabs).length > 0" id="frame_report" src="" frameborder="0" style="border:0" allowfullscreen></iframe>
    <div class="empty-reports-txt text-left" v-if="tabs == null || Object.keys(tabs).length === 0">
      <h4 class="card-title no-reports-copy">No Reports</h4>
    </div>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
// import Vue from 'vue'
import $ from 'jQuery'

const MAX_WIDTH = 1200
const MAX_HEIGHT = 3550

export default {
  mounted: function () {
    $('.nav-link').removeClass('active')
    const el = $('.nav-link').first()
    el.addClass('active')
    if (this.tabs == null || Object.keys(this.tabs).length === 0) {
      return {}
    }
    $('#frame_report').attr('src', this.tabs[el.text()].url)
    this.resizeFrame(this.tabs[el.text()], MAX_WIDTH)
    const _this = this
    $(window).resize(function () {
      const el = $('#nav_report').find('.active').first()
      _this.resizeFrame(_this.tabs[el.text()], $(window).width())
    })
  },
  created: function () {},
  props: {},
  data: function () {
    return {title: 'Analytics'}
  },
  components: {},
  computed: {
    tabs: function () {
      let t = this.$store.getters.organization._reports
      if (t == null) {
        return {}
      }
      let tabs = {}
      let keys = Object.keys(t)
      for (let key of keys) {
        let url = (t[key].url) ? t[key].url : t[key]
        tabs[key] = { id: key.split(' ').join('').toLowerCase(), url: url, width: t[key].width, height: t[key].height }
      }
      return tabs
    }
  },
  methods: {
    loadTab: function (idx) {
      $('.nav-link').removeClass('active')
      let el = $('#' + idx)
      el.addClass('active')
      $('#frame_report').attr('src', 'about:blank')
      const url = this.tabs[el.text()].url
      this.resizeFrame(this.tabs[el.text()], MAX_WIDTH)
      setTimeout(() => {
        $('#frame_report').attr('src', url)
      }, 200)
    },
    resizeFrame: function (tab, newWidth) {
      const ratio = MAX_HEIGHT / MAX_WIDTH
      let width = (newWidth > MAX_WIDTH) ? MAX_WIDTH : newWidth
      let height = parseInt(width * ratio)

      if (tab.width && tab.height && tab.width < width) {
        width = parseInt(tab.width)
        height = parseInt(tab.height)
      } else if (tab.width && !tab.height && tab.width < width) {
        width = parseInt(tab.width)
        height = parseInt(width * ratio)
      } else if (!tab.width && tab.height) {
        width = parseInt(width)
        height = parseInt(tab.height)
      }
      $('#frame_report').css('maxWidth', width + 'px')
      $('#frame_report').css('width', '100%')
      $('#frame_report').css('maxHeight', height + 'px')
      $('#frame_report').css('height', height + 'px')
    }
  }
}
</script>
<style scoped>

#frame_report {
  background-color: #EEEEEE;
 }

#report_container {
  min-height: 100%;
  min-width: 100%;
}

.empty-reports-txt {
}

#frame_report {
  background-color: #EEEEEE;
 }

#report_container {
  min-height: 100%;
  min-width: 100%;
}

.empty-reports-txt {
}

.nav-item {
  font-size: 18px;
  font-family: "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
  color: #2F87BE;
}

.nav-tabs .nav-link.active, .nav-tabs .nav-link, .nav-tabs .navbar .active.dropdown-toggle, .navbar .nav-tabs .active.dropdown-toggle {
  color: #2F87BE;
}

.reports-content {
  margin: 28px 0px 0px 0px;
  padding: 20px;
}

.no-reports-copy {
  font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// Reports.vue?6ebb45da